export default __webpack_public_path__ + "assets/images/No-Negative-21f7af377b7e96f9ccffbb487bba5cd1.svg";